// @flow

import { useMemo } from 'react'
import { drop } from 'ramda'

import { languages } from '@alphaott/app-dictionary'
import { DEFAULT_LANGUAGE_OPTION, DISABLED_LANGUAGE_OPTION } from '@alphaott/app-config'

import { useTranslateDefaultLanguageOption } from './useTranslateDefaultLanguageOption'

type LanguageItem = { key: string, nativeName: string }

export const usePrepareLanguageList = (withoutDisableOption?: boolean, customLanguages?: LanguageItem[]) => {
  const defaultLanguageOption = useTranslateDefaultLanguageOption(DEFAULT_LANGUAGE_OPTION)
  const disabledLanguageOption = useTranslateDefaultLanguageOption(DISABLED_LANGUAGE_OPTION)

  // eslint-disable-next-line complexity
  const preparedLanguages = useMemo(() => {
    const sourceLanguages = customLanguages && customLanguages.length > 0 ? customLanguages : languages
    const list = [disabledLanguageOption, defaultLanguageOption, ...sourceLanguages]

    return withoutDisableOption ? drop(1, list) : list
  }, [defaultLanguageOption, disabledLanguageOption, withoutDisableOption, customLanguages])

  return preparedLanguages
}
